// extracted by mini-css-extract-plugin
export default {"root":"TextResult_root__oVb5R","text":"TextResult_text__ITrlI","highlight":"TextResult_highlight__uJXaa"};